import type { Social_Networks } from "~/core";

export const isSocialNetworks = (item: unknown): item is Social_Networks => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "social_networks"
  );
};
